import * as React from "react";
import {lazyInject} from "@athena-portal/core";
import {IFalconConvenienceApiService, LvToAllianzUKTransferBannerHelper, Settings, Types} from "@ferry/journey-services";
import {InfoBanner} from "@ferry/portal-core";

interface IProps {}

interface IState {
    isBannerEnabled: boolean;
    wording: string | undefined;
}

export class LvToAllianzUKTransferDashboardBanner extends React.Component<IProps, IState> {
    @lazyInject(Types.FalconConvenienceApiService)
    protected readonly falconConvenienceApiService: IFalconConvenienceApiService;

    constructor(props: any) {
        super(props);

        this.state = {
            isBannerEnabled: false,
            wording: undefined
        }
    }

    public componentDidMount() {
        this.falconConvenienceApiService.getSettings().subscribe(
            (settings: Settings) => LvToAllianzUKTransferBannerHelper.setBannerWidgetState(
                settings,
                (state: IState) => this.setState(state)
            )
        );
    }

    public render() {
        if (!this.state.isBannerEnabled) {
            return <></>;
        }

        return (
            <InfoBanner
                wording={
                    <>
                        <p className="fs-22 mb-3">
                            <strong>We’re planning some changes to our business</strong>
                        </p>
                        <p className="mb-0">
                            {this.state.wording} You can find out more information about the transfer at{" "}
                            <a className="font-weight-normal" href="https://www.allianz.co.uk/transfer" id="transfer" target="_blank">
                                www.allianz.co.uk/transfer
                            </a>.
                        </p>
                    </>
                }
            />
        );

    }
}
